import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/**
 * Blocos de ajuda por etapa do setup (i18n: onboarding.setup.stepHelp.{stepKey}.*)
 */
export default function SetupStepHelp({ stepKey }) {
  const { t } = useTranslation("onboarding");
  const base = `setup.stepHelp.${stepKey}`;

  const blocks = useMemo(() => {
    const why = t(`${base}.why`, { defaultValue: "" });
    const howWeUse = t(`${base}.howWeUse`, { defaultValue: "" });
    const howToFill = t(`${base}.howToFill`, { defaultValue: "" });
    return [
      { k: "why", title: t("setup.stepHelp.headings.why", { defaultValue: "Por que isso importa" }), body: why },
      {
        k: "howWeUse",
        title: t("setup.stepHelp.headings.howWeUse", { defaultValue: "Como usamos na plataforma" }),
        body: howWeUse,
      },
      {
        k: "howToFill",
        title: t("setup.stepHelp.headings.howToFill", { defaultValue: "Como preencher" }),
        body: howToFill,
      },
    ].filter((x) => x.body && String(x.body).trim());
  }, [t, base]);

  if (!blocks.length) return null;

  return (
    <Accordion
      defaultExpanded={false}
      disableGutters
      elevation={0}
      sx={{
        width: "100%",
        mb: 2,
        border: (th) => `1px solid ${th.palette.divider}`,
        borderRadius: 1,
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon aria-hidden />}>
        <Typography variant="subtitle2" component="h2">
          {t("setup.stepHelp.toggleLabel", { defaultValue: "Ajuda desta etapa" })}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        {blocks.map((b) => (
          <section key={b.k} style={{ marginBottom: 12 }}>
            <Typography variant="caption" color="text.secondary" component="h3" display="block" sx={{ mb: 0.5 }}>
              {b.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-line" }}>
              {b.body}
            </Typography>
          </section>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
